import { isEn } from "project-config/utils/env";
import { LoadingWrapper, Spinner, SpinnerText } from "./atom";

export function Loading({
  fitParent,
  transparent,
  background,
  height,
  onClick,
}: {
  fitParent?: boolean;
  transparent?: boolean;
  background?: string;
  height?: string;
  onClick?: (e: any) => void;
}) {
  return (
    <LoadingWrapper
      fitParent={fitParent}
      height={height}
      background={transparent ? "transparent" : background}
      className="loading-wrapper"
      onClick={onClick}
    >
      <Spinner>
        <span className="loading-span">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </Spinner>
      <SpinnerText>{isEn() ? "Loading..." : "加载中..."}</SpinnerText>
    </LoadingWrapper>
  );
}
